// extracted by mini-css-extract-plugin
export default {"links":"resourcesstyle_links__rr-TQ","cardscontainer":"resourcesstyle_cardscontainer__KP1o7","cards":"resourcesstyle_cards__Alb4D","cardheading":"resourcesstyle_cardheading__94Uny"};